import React from "react";
import { Box, IconButton } from "@mui/material";
import { Facebook, Instagram } from "@mui/icons-material";
import facebook from "../images/facebook.svg";
import instagram from "../images/instagram.svg";

const FloatingSocialIcons = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        right: "10px",
        top: "50%",
        transform: "translateY(-50%)",
        display: "flex",
        flexDirection: "column",
        border: "1px solid #202f75",
        gap: "2px",
        zIndex: 999,
        background: "white",
        borderRadius: "8px",
      }}
    >
      {/* Facebook Icon */}
      <IconButton
        href="https://www.facebook.com/share/1E4zxGLjDN/"
        target="_blank"
        sx={{
          background: "white",
          padding: "4px",
          borderRadius: "8px",
          "&:hover": { background: "#E3E3E3" },
        }}
      >
        <img src={facebook} alt="Facebook" width="32" height="32" />
      </IconButton>

      {/* Instagram Icon */}
      <IconButton
        href="https://www.instagram.com/snoword_puzzle?utm_source=qr&igsh=ZDZiN2s1bHRocndj"
        target="_blank"
        sx={{
          background: "white",
          padding: "4px 0px",
          borderRadius: "8px",
          "&:hover": { background: "#E3E3E3" },
        }}
      >
        <img src={instagram} alt="Instagram" width="32" height="32" />
      </IconButton>
    </Box>
  );
};

export default FloatingSocialIcons;
